export const THIS_MONTH = "THIS_MONTH";
export const NEXT_MONTH = "NEXT_MONTH";
export const DEFAULT = "DEFAULT";
